import { FormArray, FormGroup } from '@angular/forms';
import { checkBoxHelper, getControl, getFormArray } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { CkNormeValuesEnum } from '../../../common/consts/ckNormeValues.enum';
import { checkCkNormeValueHelper, checkCkNormeValueRequiredHelper, setRequiredIfNormeActiveAndSecondFilledHelper } from '../../../common/helpers/norme-ck-lookup.helper';
import { formArrayRequiredHelper } from '../../../common/helpers/norme-validators.helper';

export const getNormeSpaMonisticoControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.ammControllo}.my_NormeSpaMonistico.${path}`);

export const getAmmControlloControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.ammControllo}.${path}`);

export const getSpmComitatoGestioneFormArray = (form: FormGroup): FormArray =>
    getFormArray(form, `${formPaths.ammControllo}.my_NormeSpaMonistico.my_SpmComitatoGestione.my_SpmElemComitatoGestione`);

export const checkCkNormeValue = (form: FormGroup): boolean => checkCkNormeValueHelper(form, CkNormeValuesEnum.normeSpaMonistico);

export const normeSpaMonisticoCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath = formPaths.ammControllo,
    suppCondition = true,
    errorStatus?: string
): void => checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition && checkCkNormeValue(form), errorStatus);

export const normeSpaMonisticoRequiredHelper = (form: FormGroup, targetPath: string, subFormPath = formPaths.ammControllo): void =>
    checkCkNormeValueRequiredHelper(form, targetPath, CkNormeValuesEnum.normeSpaMonistico, subFormPath);

export const setRequiredIfNormeActiveAndSecondFilled = (form: FormGroup, targetPath: string, secondFieldPath: string, subFormPath = formPaths.ammControllo): void =>
    setRequiredIfNormeActiveAndSecondFilledHelper(form, targetPath, secondFieldPath, CkNormeValuesEnum.normeSpaMonistico, subFormPath);

export const my_SpmElemComitatoGestioneRequiredHelper = (form: FormGroup, targetPath: string): void => {
    const formArray = getSpmComitatoGestioneFormArray(form);
    formArrayRequiredHelper(formArray, targetPath);
};
